import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { SubPageLayout } from '../sub-page-layout';
import { RoleEditContainer } from '../components/role-edit.container';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const RolesEdit: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Role - Edit</title>
      </Helmet>
      <SubPageLayout
        header={
          <PageHeader
            title={<Typography.Title style={{ paddingBottom: '0px', fontSize: '30px', marginTop: '12px' }}>Edit Role</Typography.Title>}
            onBack={() => navigate(-1)}
          ></PageHeader>
        }
      >
        <RoleEditContainer />
      </SubPageLayout>
    </>
  );
};
